<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      action=""
      :auto-upload="false"
      :on-change="handleFileChange"
      :file-list="fileList"
      :limit="5"
      :on-exceed="handleError"
      :on-remove="handleRemove"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
    </el-upload>
  </div>
</template>

<script>
  export default {
    props: [],
    data() {
      return {
        files: [],
        fileList: [],
        uploadKey: 0,
      };
    },


    methods: {

      async handleFileChange(file, fileList) {
          let docketFile ={
            file: {},
            source: {},
          };
          if (this.isFileCorrect(file)) {
            docketFile.file.path = URL.createObjectURL(file.raw);
            docketFile.source = file.raw;
            docketFile.size = file.raw.size;
            docketFile.extension = file.name.split('.').pop();
            docketFile.key = Math.random().toString(36).substring(7);
            this.files.push(docketFile);
            this.uploadKey++;
          } else {
            this.fileList = [];
            this.uploadKey++;
          }
      },

      handleError(files) {
        if(files.length > 5)
        this.$messageWrapper.warning('Egyszerre 5 fájl adható hozzá');
      },

      handleRemove(file) {
        this.files = this.files.filter(docketFile => docketFile.source.uid !== file.uid);
      },

      isFileCorrect(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isLt2M) {
          this.$messageWrapper.error('Fajl mérete nem lehet nagyobb, mint 10MB!');
          return isLt2M;
        }
        return isLt2M;
      },
    }
  };
</script>
